/* =========================================================
   MADSPEED7 — FLOATING CART
   Opens Candy Rack + keeps quantity badge updated
   ========================================================= */

(function () {

  function setupFloatingCart() {

    const button = document.querySelector(
      '#ms7-floating-cart'
    );

    if (!button) return;

    if (button.dataset.ms7FloatingCartSetup === 'true') {
      return;
    }

    button.addEventListener('click', function (event) {

      event.preventDefault();
      event.stopPropagation();

      const cartIcon = document.querySelector(
        '#cart-icon-bubble'
      );

      if (cartIcon) {
        cartIcon.click();
      }

    });

    button.dataset.ms7FloatingCartSetup = 'true';

  }


  /* =========================================================
     UPDATE CART QUANTITY
     ========================================================= */

  async function updateFloatingCartCount() {

    const countElement = document.querySelector(
      '#ms7-floating-cart-count'
    );

    if (!countElement) return;

    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart.js',
        {
          cache: 'no-store'
        }
      );

      const cart = await response.json();

      countElement.textContent = cart.item_count;

    } catch (error) {

      console.log(
        'MADSPEED7 floating cart count error:',
        error
      );

    }

  }


  /* =========================================================
     INITIAL LOAD
     ========================================================= */

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      setupFloatingCart();
      updateFloatingCartCount();

    }
  );


  window.addEventListener(
    'load',
    function () {

      setupFloatingCart();
      updateFloatingCartCount();

    }
  );


  /* =========================================================
     WATCH FOR SHOPIFY CART REQUESTS
     ========================================================= */

  const originalFetch = window.fetch;

  window.fetch = function () {

    const request = originalFetch.apply(this, arguments);

    request.then(function (response) {

      const url =
        typeof response.url === 'string'
          ? response.url
          : '';

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      ) {

        setTimeout(
          updateFloatingCartCount,
          300
        );

      }

    });

    return request;

  };

})();